import React from 'react';
import { CircularTestimonials } from './ui/circular-testimonials';

// Convert existing testimonial data to new format
const testimonialsData = [
  {
    quote: "I traveled from Tanzania specifically to visit Dr. Muskan after hearing about her expertise. My dental crowns and fillings are perfect - you can't tell them apart from my natural teeth! Wisdom Dental Clinic in Gurgaon provided exceptional care despite me being an international patient. The attention to detail and warm hospitality made the long journey absolutely worthwhile.",
    name: "Mbwana Athuman",
    designation: "Filling & Dental Crown Patient",
    src: "/patient0.jpeg"
  },
  {
    quote: "I was terrified when I needed a root canal, but Dr. Muskan made it completely painless. Her gentle approach and the modern facilities at Wisdom Dental Clinic in Gurgaon made the entire procedure smooth. I'm so grateful to have found such a skilled dentist who truly cares about patient comfort.",
    name: "Himanshu Mehra",
    designation: "Root Canal Patient",
    src: "/patient1.jpeg"
  },
  {
    quote: "Dr. Muskan completely transformed my smile! I had severely misaligned teeth and was very self-conscious. The orthodontic treatment at Wisdom Dental Clinic was comfortable and the results exceeded my expectations. The staff in Gurgaon is incredibly professional and made every visit pleasant.",
    name: "Sonam",
    designation: "Orthodontic Patient",
    src: "/patient2.jpeg"
  },
  {
    quote: "My teeth were stained and uneven for years. Dr. Muskan designed a complete smile makeover with veneers and whitening that has transformed my appearance. The artistic skill and attention to detail at Wisdom Dental Clinic is unmatched. I finally have the confidence to smile in photos!",
    name: "Aman",
    designation: "Cosmetic Dentistry Patient",
    src: "/patient3.jpeg"
  },
  {
    quote: "Our entire family visits Dr. Muskan at Wisdom Dental Clinic. The kid-friendly environment makes our children actually look forward to dental checkups! The preventive care advice has significantly improved our oral health. The clinic's location in Gurgaon is also very convenient for us.",
    name: "Zeba",
    designation: "General Dentistry Patient",
    src: "/patient4.jpeg"
  },
  {
    quote: "As a professional who meets clients daily, I was hesitant about getting braces. Dr. Muskan suggested Invisalign, and it was the perfect solution! The aligners were nearly invisible, and the results were fantastic. The digital scanning technology at Wisdom Dental Clinic is state-of-the-art.",
    name: "Shazia",
    designation: "Invisalign Patient",
    src: "/patient6.jpeg"
  },
  {
    quote: "When I cracked my tooth on a weekend, Wisdom Dental Clinic accommodated me immediately. Dr. Muskan's emergency care was exceptional – she relieved my pain quickly and fixed my tooth beautifully. Their commitment to patient care in Gurgaon is remarkable, even outside regular hours.",
    name: "Yashita",
    designation: "Dental Emergency Patient",
    src: "/patient5.jpeg"
  },
  {
    quote: "I'd been struggling with gum disease for years before consulting Dr. Muskan. Her thorough approach to periodontal treatment has completely reversed my condition. The hygienists at Wisdom Dental Clinic also taught me proper maintenance techniques. My gums are healthier than they've been in decades!",
    name: "Bilal",
    designation: "Gum Treatment Patient",
    src: "/patient7.jpeg"
  }
];

const TestimonialCarousel = () => {
  return (
    <div className="testimonial-section-wrapper" style={{ padding: '4rem 1rem', backgroundColor: '#f7f7fa' }}>
      <div style={{ maxWidth: '1456px', margin: '0 auto' }}>
        <h2 style={{ 
          textAlign: 'center', 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          marginBottom: '3rem',
          color: '#0a0a0a'
        }}>
          Happy Patients
        </h2>
        <CircularTestimonials
          testimonials={testimonialsData}
          autoplay={true}
          colors={{
            name: "#0a0a0a",
            designation: "#454545",
            testimony: "#171717",
            arrowBackground: "#141414",
            arrowForeground: "#f1f1f7",
            arrowHoverBackground: "#00A6FB",
          }}
          fontSizes={{
            name: "28px",
            designation: "20px",
            quote: "20px",
          }}
        />
      </div>
    </div>
  );
};

export default TestimonialCarousel;
